import React from "react";
import {Table} from "react-bootstrap";
import ManualRow from "./ManualRow";
import {IImageManualModel} from "../../types/manualFinder";
import {useTranslation} from "react-i18next";
import {OverlayTooltip} from "../../components";

interface MatchingManualsTableProps {
    manuals: IImageManualModel[];
    setIsLoading: (loading: boolean) => void;
}

const MatchingManualsTable: React.FC<MatchingManualsTableProps> = ({manuals, setIsLoading}) => {
    const {t} = useTranslation();

    return (
        <Table bordered hover responsive>
            <thead>
            <tr>
                <th>ID</th>
                <th>{t("Manual.ItemMpText")}</th>
                <th>{t("Manual.ManualName")}</th>
                <th>
                    <div className="d-flex flex-row gap-2 align-items-baseline">
                        {t("AutomaticImageSelection.CountFoundImages")}
                        <OverlayTooltip tooltipContent={t('AutomaticImageSelection.CountFoundImagesTooltip')}/>
                    </div>
                </th>
                <th>{t("AutomaticImageSelection.FoundImages")}</th>
            </tr>
            </thead>
            <tbody>
            {manuals.map((manual, index) => (
                <ManualRow key={index} manual={manual} setIsLoading={setIsLoading}/>
            ))}
            </tbody>
        </Table>
    );
};

export default MatchingManualsTable;
